import { connect } from 'react-redux';
import {
  fetchTransformedPayloadFromEditorForRest,
  probeGetSample,
  updateFormData,
} from '../../../actions';
import { getCurrentOrg } from '../../../reducers/selectors';
import { PROBE_GET_SAMPLE_REQUEST } from '../../../constants/actionTypes';
import ConfigureTemplatizedAPISink from './ConfigureTemplatizedAPISink';

const mapStateToProps = (state, ownProps) => {
  const { formType, selectedCredentialId } = ownProps;
  const {
    entities: { credentials, vendors, vendorEndpoints },
    paging,
    request,
    forms,
    schemaSpecs: { flatSchemas: schemaSpecSchemas },
    probe,
  } = state;
  const formData = forms[formType] ? forms[formType].data : {};
  const { sinkConfig, dataSetId, toNested, outputSchema } = formData;
  const probeSample = probe[selectedCredentialId];
  const isLoadingAPIResponse = !!request[PROBE_GET_SAMPLE_REQUEST];

  return {
    paging,
    vendors,
    vendorEndpoints,
    credentials,
    schemaSpecSchemas,
    currentOrg: getCurrentOrg(state),
    templatizedAPIConfig: sinkConfig,
    outputSchema,
    dataSetId,
    samples: toNested,
    probeSample, // for vendor_resource_data params
    isLoadingAPIResponse, // for vendor_resource_data params
    // pass through parent dataset information for macro replacement
    parentDataSet: ownProps.parentDataSet,
    parentDataSetSamples: ownProps.parentDataSetSamples,
  };
};

export default connect(mapStateToProps, {
  updateFormData,
  probeGetSample,
  fetchTransformedPayloadFromEditorForRest,
})(ConfigureTemplatizedAPISink);
